import React from "react";
export const MetricSkeleton = () => {
    return (React.createElement("div", { className: "onvo-flex onvo-items-end onvo-space-x-2 onvo-flex-grow onvo-h-full onvo-w-full onvo-relative" },
        React.createElement("div", { className: "onvo-h-10 onvo-w-2/3 onvo-bg-black/10 dark:onvo-bg-white/10 onvo-rounded" }),
        React.createElement("div", { className: "onvo-h-5 onvo-w-1/3 onvo-bg-black/10 dark:onvo-bg-white/10 onvo-rounded" })));
};
//# sourceMappingURL=metric.js.map